import { useQuery } from "react-query";
import { api } from "utils/api";
import { submissionKeys } from "./queryKeys";
import type { SubmissionArtistDetails } from "../types";

const getSubmissionArtistName = () =>
  api.get<SubmissionArtistDetails>("/open-call/submission/artist/detail");

/**
 * Fetch the user's Artist display name, or application name, if they have one
 */
const useSubmissionArtistName = () =>
  useQuery(submissionKeys.myArtistName(), getSubmissionArtistName);

export { useSubmissionArtistName };
